type BookingSchedule = {
  startTime: Date;
  endTime: Date;
  bookingClosesAt: Date | null;
};

/** A configured window may stay open during the event, but never past its end. */
export function eventBookingDeadline(occurrence: BookingSchedule): Date {
  const close = occurrence.bookingClosesAt ?? occurrence.startTime;
  return close < occurrence.endTime ? close : occurrence.endTime;
}

export function isEventBookingWindowOpen(
  occurrence: BookingSchedule & { bookingOpensAt: Date | null },
  now: Date,
): boolean {
  return (
    (!occurrence.bookingOpensAt || occurrence.bookingOpensAt <= now) &&
    now < eventBookingDeadline(occurrence)
  );
}

/** The effective deadline also handles legacy cutoffs saved after the event end. */
export function getEventBookingWindowError(
  occurrence: BookingSchedule & { bookingOpensAt?: Date | null },
): string | null {
  if (occurrence.endTime <= occurrence.startTime) {
    return "Event end must be after event start.";
  }
  if (
    occurrence.bookingOpensAt &&
    occurrence.bookingOpensAt >= eventBookingDeadline(occurrence)
  ) {
    return "Booking open must be before booking close and the event end.";
  }
  return null;
}
